module.exports = __webpack_public_path__ + "img/featured_bg.32785aa.svg";